import { Icon } from "./Icon.tsx";

/** "Longitudinal Profile" icon — a simple terrain/elevation profile line. */
export function ProfileIcon() {
  return (
    <Icon>
      <path d="M3 18 8 9l4 5 3-8 6 12" />
    </Icon>
  );
}
